import React, { useState }  from "react";
import { AppInputField, AppInputFieldBtn, AppInputFieldSelect, InputFieldTitleText } from '../../../../../widget/styledComponents/input_field.style'
import { Button, Spinner, toaster } from "evergreen-ui";
import Cookies from 'js-cookie' 
import { PickPropertyType } from "../widget/property_widget_compnent";
import { gql, useMutation,useQuery } from '@apollo/client';


export const UPDATE_PROPERTY = gql`
mutation Property_update($propertyUpdateId: ID!, $type: PropertyTypes!, $address: String!, $tags: [TagInput!]!, $owner: ID, $numberOfRooms: Int!, $squareMeter: Float) {
  property_update(id: $propertyUpdateId, type: $type, address: $address, tags: $tags, owner: $owner, numberOfRooms: $numberOfRooms, squareMeter: $squareMeter) {
    code
    error
    success
  }
}
`;

function About(props) {
const details = props.details
const accesTokenValue = Cookies.get('userAccessToken');

const [updateProperty, { loading }] = useMutation(UPDATE_PROPERTY);

const [turnOnEdit,setTurnOnEdit] = useState(false)
const [dataObject, setDataObject] = useState({
  propertyUpdateId: details._id,
  address:details.address,
  tags: [
    {
      "name": "name",
      "value": "value"
    }
  ],
});

const handleInputChange = (event) => {
  const { name, value } = event.target;
  let va = value



    if(name ==='numberOfRooms'){
      va = parseInt(value)
    }else if(name==="squareMeter"){
      va = parseFloat(value)
      let floatValue = va.toFixed(1);
      console.log("save as flit",typeof floatValue)
      va = parseFloat(floatValue)
      console.log("save as flit",typeof va)
    }
    setDataObject({
      ...dataObject,
      [name]: va
    });
  
};


const handleOwnerSelect = (value) => {
  setDataObject({
    ...dataObject,
    ownerId:value
  });
};
const handlePropertySelect  = (value) => {
  console.log(value)
  setDataObject({
    ...dataObject,
    type:value
  });
};


const handleSubmit=(e)=>{
  e.preventDefault()


  console.log(dataObject)
  
  updateProperty({
    variables:dataObject,
    context: {
      headers: {
        Authorization: `Bearer ${accesTokenValue}`,
      },
    },
  })
  .then((response) => {
    toaster.success("Property Updated successfully.")
    window.location.reload()
  })
  .catch((error) => {
    toaster.danger(error.message)
  });
}

  return (
    <div>
     
      {!details.owner  &&
        <div>
          <p>Please attach an owner to this property</p>
          
          
          <PickOwner onSelect={handleOwnerSelect}/>
          <br/>
          <div className='' style={{
              width:"120px",
          }}>
              <AppInputFieldBtn type='submit'  disabled>
                  Add
              </AppInputFieldBtn>
          </div>
        </div>
      }

      {turnOnEdit && details.owner &&
        <form onSubmit={handleSubmit}>
          <div>
            <div className='row'>
              <div className='col s12 m4'>
                <InputFieldTitleText>
                  Address
                  </InputFieldTitleText>
                  <AppInputField
                      type="text" 
                      placholder="alijames@gmail.com"
                      value={dataObject.address}
                      name="address" 
                      onChange={handleInputChange}
                  /> 
                </div>
                <div className='col s12 m4'>
                  <InputFieldTitleText>
                    Owner
                  </InputFieldTitleText>
                  <PickOwner onSelect={handleOwnerSelect}/>
                
                </div>
                <div className='col s12 m4'>
                  <InputFieldTitleText>
                    Property Type 
                  </InputFieldTitleText>
                  <PickPropertyType onSelect={handlePropertySelect}/>
                 
                </div>
                
            </div>
            <div className="row">
              <div className='col s12 m4'>
                <InputFieldTitleText>
                  Number of rooms
                </InputFieldTitleText>
                <AppInputField
                    type="text" 
                    name="numberOfRooms"
                    onChange={handleInputChange}
                /> 
              </div>
              <div className='col s12 m4'>
                <InputFieldTitleText>
                  Square meter
                </InputFieldTitleText>
                <AppInputField
                    type="text" 
                    name="squareMeter"
                    onChange={handleInputChange}
                /> 
              </div>
            </div>
            <div className="row">
              <div className='col s12 m3'>
                <AppInputFieldBtn className=''
                    type="submit"
                    disabled={loading}
                    // onClick={()=>{
                    //   toaster.warning("Please reach out to propatize support.")
                    // }}
                  >
                        {loading &&
                            <center>
                              <Spinner/>
                            </center>
                        }
                        {!loading &&
                          'Edit property'
                        }   
                  </AppInputFieldBtn>
              </div>
            </div>
          </div>
        </form>
      }

      {!turnOnEdit && details.owner &&
        <div>
          
          <div className="row">
            <div className="col s12 right">
              <div className="right">
                <Button onClick={()=>{
                  setTurnOnEdit(true)
                }}>
                  Edit
                </Button>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col s12 m4'>
              <InputFieldTitleText>
                Address
                </InputFieldTitleText>
                <AppInputField
                    type="text" 
                    placholder="alijames@gmail.com"
                    value={details.address}
                    disabled
                /> 
              </div>
              <div className='col s12 m4'>
                <InputFieldTitleText>
                  Owner
                </InputFieldTitleText>
                <AppInputField
                    type="text" 
                    placholder="alijames@gmail.com"
                    value={details.owner.name}
                    readOnly
                    disabled
                /> 
              </div>
              <div className='col s12 m4'>
                <InputFieldTitleText>
                  Property Type 
                </InputFieldTitleText>
                <AppInputField
                    type="text" 
                    placholder="alijames@gmail.com"
                    value={details.type}
                    readOnly
                    disabled
                /> 
              </div>
              
          </div>
          <div className="row">
            <div className='col s12 m4'>
              <InputFieldTitleText>
                Number of rooms
              </InputFieldTitleText>
              <AppInputField
                  type="text" 
                  value={details.numberOfRooms}
                  readOnly
                  disabled
              /> 
            </div>
            <div className='col s12 m4'>
              <InputFieldTitleText>
                Square meter
              </InputFieldTitleText>
              <AppInputField
                  type="text" 
                  value={details.squareMeter}
                  readOnly
                  disabled
              /> 
            </div>
          </div>
         
        </div>
      }

      
      
    </div>
  )
}

export default About

export const FETCH_OWNERS_LIST = gql`
query Owners_getByFacility($facilityId: ID!, $pagination: PaginationInput!) {
  owners_getByFacility(facilityId: $facilityId, pagination: $pagination) {
    _id
    id
    email
    name
    phone
    photo
    facility
    isAccountActivated
    createdAt
  }
}
`;
  const PickOwner = ({ onSelect }) => {
    const facilityId = Cookies.get('facilityId');
    
    const { loading,error,data }  = useQuery(FETCH_OWNERS_LIST,{
    variables: {
        facilityId:facilityId,
        pagination: {
            "cursor": null,
            "limit": 1000
        },
        },
    });
    
    const [selectedOption, setSelectedOption] = useState('');
    
    if (loading) return <Spinner/>;
    if (error) return <p>Error: {error.message}</p>;
    const options = data.owners_getByFacility;
    const handleSelect = (event) => {
      const selectedValue = event.target.value;
      setSelectedOption(selectedValue);
      console.log("Selected value:", selectedValue);
      onSelect(selectedValue)
    };
      return (
        <div>
            <AppInputFieldSelect
                className="browser-default" required
                 value={selectedOption} onChange={handleSelect}
                >
                <option value="" disabled selected>Choose your option</option>
                {options.map((option) => (
                <option key={option.id}  value={option.id}
                >
                    {option.name}
                </option >
                ))}
            </AppInputFieldSelect>
        </div>
      )
}
    